import type React from 'react';
import styled from 'styled-components';

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

interface OverlayProps {
  children?: React.ReactNode;
  onClick?: () => void;
}

const Overlay: React.FC<OverlayProps> = ({ children, onClick }) => {
  return (
    <StyledOverlay onClick={onClick} data-testid="popup-overlay">
      {children}
    </StyledOverlay>
  );
};

export default Overlay;
